(() => {
  const host = document.getElementById('wkolo-support-safe');
  if (!host || host.dataset.mounted === '1') return;
  host.dataset.mounted = '1';

  const ENDPOINT = host.dataset.endpoint || '';
  const PRODUCT_TITLE = (host.dataset.productTitle || '').trim();
  const HISTORY_KEY = 'wkolo_support_safe_history';
  const MAX_HISTORY = 8;

  // Shadow DOM izoluje widget od CSS motywu Shopify.
  const shadow = host.attachShadow({ mode: 'open' });

  shadow.innerHTML = `
    <style>
      :host {
        all: initial;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
      }

      *, *::before, *::after {
        box-sizing: border-box;
      }

      .wrap {
        position: fixed;
        right: 20px;
        bottom: 20px;
        z-index: 2147483000;
        color: #171717;
        font-family: inherit;
      }

      button,
      textarea,
      a {
        font: inherit;
      }

      .launcher {
        min-width: 208px;
        height: 58px;
        border: 0;
        border-radius: 999px;
        padding: 7px 17px 7px 8px;
        display: flex;
        align-items: center;
        gap: 10px;
        background: #171717;
        color: #fff;
        box-shadow: 0 12px 34px rgba(0,0,0,.24);
        cursor: pointer;
      }

      .launcher:hover {
        transform: translateY(-1px);
      }

      .launcher-icon {
        width: 42px;
        height: 42px;
        flex: 0 0 42px;
        border-radius: 50%;
        display: grid;
        place-items: center;
        background: rgba(255,255,255,.12);
        font-weight: 800;
      }

      .launcher-copy {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 1.15;
      }

      .launcher-copy strong {
        font-size: 14px;
      }

      .launcher-copy span {
        margin-top: 3px;
        font-size: 11px;
        opacity: .7;
      }

      .panel {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 440px;
        max-width: calc(100vw - 24px);
        height: min(720px, calc(100vh - 30px));
        overflow: hidden;
        display: none;
        grid-template-rows: auto auto auto 1fr auto auto;
        border: 1px solid #deded9;
        border-radius: 20px;
        background: #fff;
        box-shadow: 0 24px 70px rgba(0,0,0,.28);
      }

      .panel.open {
        display: grid;
      }

      .wrap.open .launcher {
        display: none;
      }

      .header {
        min-height: 66px;
        padding: 12px 13px 11px 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e7e7e2;
      }

      .brand {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .avatar {
        width: 38px;
        height: 38px;
        border-radius: 11px;
        display: grid;
        place-items: center;
        background: #171717;
        color: #fff;
        font-size: 15px;
        font-weight: 800;
      }

      .brand-title {
        font-size: 14px;
        font-weight: 750;
      }

      .brand-subtitle {
        margin-top: 2px;
        color: #74746e;
        font-size: 11px;
      }

      .close {
        width: 38px;
        height: 38px;
        border: 0;
        border-radius: 50%;
        background: transparent;
        color: #171717;
        font-size: 27px;
        line-height: 1;
        cursor: pointer;
      }

      .close:hover {
        background: #f3f3ef;
      }

      .intro {
        padding: 12px 15px 8px;
      }

      .intro strong {
        display: block;
        font-size: 16px;
        line-height: 1.25;
      }

      .intro span {
        display: block;
        margin-top: 3px;
        color: #73736d;
        font-size: 12px;
        line-height: 1.4;
      }

      .chips {
        padding: 2px 13px 11px;
        display: flex;
        gap: 7px;
        overflow-x: auto;
        scrollbar-width: none;
      }

      .chips::-webkit-scrollbar {
        display: none;
      }

      .chip {
        flex: 0 0 auto;
        border: 1px solid #d5d5cf;
        border-radius: 999px;
        padding: 8px 11px;
        background: #fff;
        color: #252525;
        font-size: 12px;
        cursor: pointer;
      }

      .chip:hover {
        background: #f5f5f1;
      }

      .messages {
        min-height: 0;
        overflow-y: auto;
        padding: 15px 13px 18px;
        background: #f7f7f4;
        scrollbar-width: thin;
      }

      .row {
        display: flex;
        margin: 0 0 10px;
      }

      .row.user {
        justify-content: flex-end;
      }

      .row.assistant {
        justify-content: flex-start;
      }

      .stack {
        width: min(92%, 390px);
        display: grid;
        gap: 8px;
      }

      .bubble {
        width: fit-content;
        max-width: 100%;
        padding: 10px 12px;
        border-radius: 14px;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        font-size: 13px;
        line-height: 1.48;
      }

      .assistant .bubble {
        border: 1px solid #e2e2dc;
        border-bottom-left-radius: 5px;
        background: #fff;
      }

      .user .bubble {
        margin-left: auto;
        border-bottom-right-radius: 5px;
        background: #171717;
        color: #fff;
      }

      .pending {
        color: #74746e;
      }

      .cards {
        display: grid;
        gap: 8px;
      }

      .card {
        display: grid;
        grid-template-columns: 68px minmax(0, 1fr);
        gap: 10px;
        padding: 9px;
        border: 1px solid #e1e1dc;
        border-radius: 14px;
        background: #fff;
      }

      .cover {
        width: 68px;
        height: 92px;
        overflow: hidden;
        border-radius: 8px;
        background: #edede8;
      }

      .cover img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }

      .card-body {
        min-width: 0;
        display: flex;
        flex-direction: column;
      }

      .vendor {
        margin-bottom: 2px;
        color: #7c7c76;
        font-size: 9px;
        text-transform: uppercase;
        letter-spacing: .04em;
      }

      .title {
        color: #171717;
        text-decoration: none;
        font-size: 12.5px;
        font-weight: 750;
        line-height: 1.3;
      }

      .price {
        margin-top: 5px;
        font-size: 13px;
        font-weight: 750;
      }

      .actions {
        margin-top: auto;
        padding-top: 7px;
        display: flex;
        gap: 6px;
      }

      .view,
      .add {
        min-height: 31px;
        padding: 7px 9px;
        border-radius: 8px;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 650;
        cursor: pointer;
      }

      .view {
        border: 1px solid #d5d5cf;
        color: #171717;
        background: #fff;
      }

      .add {
        border: 1px solid #171717;
        background: #171717;
        color: #fff;
      }

      .add:disabled {
        opacity: .5;
        cursor: default;
      }

      .add.done {
        background: #23663c;
        border-color: #23663c;
      }

      .product-context {
        display: none;
        padding: 7px 11px;
        gap: 6px;
        overflow-x: auto;
        border-top: 1px solid #e7e7e2;
        background: #fff;
      }

      .product-context.visible {
        display: flex;
      }

      .composer {
        padding: 9px 10px;
        display: grid;
        grid-template-columns: 1fr 43px;
        gap: 7px;
        align-items: end;
        border-top: 1px solid #e7e7e2;
        background: #fff;
      }

      .input {
        width: 100%;
        min-height: 43px;
        max-height: 105px;
        resize: none;
        border: 1px solid #d6d6d0;
        border-radius: 12px;
        padding: 11px 12px;
        outline: none;
        background: #fff;
        color: #171717;
        font-size: 13px;
        line-height: 1.4;
      }

      .input:focus {
        border-color: #92928b;
      }

      .send {
        width: 43px;
        height: 43px;
        border: 0;
        border-radius: 11px;
        display: grid;
        place-items: center;
        background: #171717;
        color: #fff;
        cursor: pointer;
        font-size: 17px;
      }

      .send:disabled,
      .chip:disabled {
        opacity: .45;
        cursor: default;
      }

      .note {
        padding: 0 10px 9px;
        background: #fff;
        color: #92928b;
        text-align: center;
        font-size: 9px;
      }

      .nudge {
        position: absolute;
        right: 0;
        bottom: 68px;
        width: 225px;
        display: none;
        padding: 12px 34px 12px 13px;
        border: 1px solid #dfdfd9;
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 10px 28px rgba(0,0,0,.14);
        cursor: pointer;
      }

      .nudge.show {
        display: block;
      }

      .nudge strong {
        display: block;
        font-size: 13px;
      }

      .nudge span {
        display: block;
        margin-top: 3px;
        color: #73736d;
        font-size: 11px;
        line-height: 1.35;
      }

      .nudge-x {
        position: absolute;
        top: 5px;
        right: 6px;
        width: 24px;
        height: 24px;
        border: 0;
        background: transparent;
        cursor: pointer;
        font-size: 19px;
        color: #555;
      }

      @media (max-width: 640px) {
        .wrap {
          left: 8px;
          right: 8px;
          bottom: max(8px, env(safe-area-inset-bottom));
        }

        .launcher {
          width: 100%;
          justify-content: center;
        }

        .panel {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100vw;
          max-width: none;
          height: 88dvh;
          max-height: 88dvh;
          border-radius: 18px 18px 0 0;
          border-bottom: 0;
        }

        .nudge {
          right: 8px;
          bottom: 66px;
          width: min(240px, calc(100vw - 32px));
        }
      }
    </style>

    <div class="wrap">
      <div class="nudge" aria-hidden="true">
        <button class="nudge-x" type="button" aria-label="Zamknij">×</button>
        <strong>Szukasz książki?</strong>
        <span>Support dobierze maksymalnie 3 tytuły.</span>
      </div>

      <button class="launcher" type="button">
        <span class="launcher-icon">W</span>
        <span class="launcher-copy">
          <strong>Dobierz mi książkę</strong>
          <span>Support WKOŁO</span>
        </span>
      </button>

      <section class="panel" aria-hidden="true">
        <header class="header">
          <div class="brand">
            <div class="avatar">W</div>

            <div>
              <div class="brand-title">Support · WKOŁO</div>
              <div class="brand-subtitle">Doradca książkowy</div>
            </div>
          </div>

          <button class="close" type="button" aria-label="Zamknij">×</button>
        </header>

        <div class="intro">
          <strong>Znajdź dobrą książkę</strong>
          <span>Wybierz temat albo napisz własnymi słowami, czego szukasz.</span>
        </div>

        <div class="chips">
          <button
            class="chip"
            type="button"
            data-prompt="Poleć mi 3 najlepsze książki o treningu kolarskim."
          >
            Trening
          </button>

          <button
            class="chip"
            type="button"
            data-prompt="Poleć mi 3 najlepsze biografie kolarskie."
          >
            Biografie
          </button>

          <button
            class="chip"
            type="button"
            data-prompt="Szukam dobrej książki rowerowej na prezent. Poleć maksymalnie 3."
          >
            Na prezent
          </button>

          <button
            class="chip"
            type="button"
            data-prompt="Poleć mi 3 książki o podróżach rowerowych lub bikepackingu."
          >
            Podróże
          </button>
        </div>

        <div class="messages"></div>

        <div class="product-context">
          <button class="chip context-a" type="button">
            Czy ta książka jest dla mnie?
          </button>

          <button class="chip context-b" type="button">
            Porównaj z innymi
          </button>
        </div>

        <div class="composer">
          <textarea
            class="input"
            rows="1"
            maxlength="700"
            placeholder="Np. szukam książki o treningu z mocą…"
          ></textarea>

          <button class="send" type="button" aria-label="Wyślij">
            ➜
          </button>
        </div>

        <div class="note">
          Ceny i dostępność Support sprawdza w katalogu WKOŁO.
        </div>
      </section>
    </div>
  `;

  const $ = sel => shadow.querySelector(sel);
  const $$ = sel => [...shadow.querySelectorAll(sel)];

  const wrap = $('.wrap');
  const panel = $('.panel');
  const launcher = $('.launcher');
  const closeBtn = $('.close');
  const messages = $('.messages');
  const input = $('.input');
  const send = $('.send');
  const chips = $$('.chip[data-prompt]');
  const context = $('.product-context');
  const contextA = $('.context-a');
  const contextB = $('.context-b');
  const nudge = $('.nudge');
  const nudgeX = $('.nudge-x');

  let busy = false;
  let history = loadHistory();

  function loadHistory() {
    try {
      const value = JSON.parse(
        sessionStorage.getItem(HISTORY_KEY) || '[]'
      );

      if (!Array.isArray(value)) {
        return [];
      }

      return value
        .filter(
          x =>
            x &&
            ['user', 'assistant'].includes(x.role) &&
            typeof x.content === 'string'
        )
        .slice(-MAX_HISTORY);
    } catch {
      return [];
    }
  }

  function saveHistory() {
    try {
      sessionStorage.setItem(
        HISTORY_KEY,
        JSON.stringify(history.slice(-MAX_HISTORY))
      );
    } catch {}
  }

  function openPanel() {
    wrap.classList.add('open');
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');

    nudge.classList.remove('show');

    setTimeout(() => {
      input.focus();
    }, 50);
  }

  function closePanel() {
    wrap.classList.remove('open');
    panel.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true');
  }

  function scrollBottom() {
    messages.scrollTop = messages.scrollHeight;
  }

  function addMessage(role, text, pending = false) {
    const row = document.createElement('div');
    row.className = `row ${role}`;

    const stack = document.createElement('div');
    stack.className = 'stack';

    const bubble = document.createElement('div');
    bubble.className = `bubble${pending ? ' pending' : ''}`;
    bubble.textContent = text;

    stack.appendChild(bubble);
    row.appendChild(stack);
    messages.appendChild(row);

    scrollBottom();

    return {
      row,
      stack,
      bubble
    };
  }

  function setBubble(bubble, text) {
    bubble.classList.remove('pending');
    bubble.textContent = text;
    scrollBottom();
  }

  function setBusy(value) {
    busy = value;

    send.disabled = value;
    input.disabled = value;

    chips.forEach(x => {
      x.disabled = value;
    });

    contextA.disabled = value;
    contextB.disabled = value;
  }

  function autoGrow() {
    input.style.height = 'auto';

    input.style.height =
      Math.min(input.scrollHeight, 105) + 'px';
  }

  function productRefs(text) {
    const re =
      /https?:\/\/(?:www\.)?wkolo\.pl\/products\/([a-z0-9-]+)/gi;

    const seen = new Set();
    const result = [];

    for (const m of text.matchAll(re)) {
      const handle = m[1].toLowerCase();

      if (!seen.has(handle)) {
        seen.add(handle);
        result.push(handle);
      }

      if (result.length === 3) {
        break;
      }
    }

    return result;
  }

  function stripProductUrls(text) {
    return text
      .replace(
        /\s*https?:\/\/(?:www\.)?wkolo\.pl\/products\/[a-z0-9-]+/gi,
        ''
      )
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  async function fetchProduct(handle) {
    const r = await fetch(
      `/products/${encodeURIComponent(handle)}.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!r.ok) {
      throw new Error(
        `product ${r.status}`
      );
    }

    return r.json();
  }

  function money(cents) {
    if (typeof cents !== 'number') {
      return '';
    }

    return new Intl.NumberFormat(
      'pl-PL',
      {
        style: 'currency',
        currency: 'PLN',
        maximumFractionDigits:
          cents % 100 === 0 ? 0 : 2
      }
    ).format(cents / 100);
  }

  async function addToCart(id, btn) {
    if (!id || btn.disabled) {
      return;
    }

    const old =
      btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Dodaję…';

    try {
      const rootRoute =
        window.Shopify?.routes?.root ||
        '/';

      const r = await fetch(
        rootRoute + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id,
                quantity: 1
              }
            ]
          })
        }
      );

      if (!r.ok) {
        throw new Error(
          await r.text()
        );
      }

      btn.textContent = 'Dodano ✓';
      btn.classList.add('done');

      document.dispatchEvent(
        new CustomEvent(
          'wkolo:cart-added',
          {
            detail: {
              variantId: id
            }
          }
        )
      );

      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = old;
        btn.classList.remove('done');
      }, 2500);
    } catch (e) {
      console.error(
        '[WKOŁO Support] cart',
        e
      );

      btn.disabled = false;
      btn.textContent =
        'Spróbuj ponownie';

      setTimeout(() => {
        btn.textContent = old;
      }, 1800);
    }
  }

  function buildCard(
    product,
    handle
  ) {
    const card =
      document.createElement(
        'article'
      );

    card.className = 'card';

    const coverLink =
      document.createElement('a');

    coverLink.className = 'cover';
    coverLink.href =
      `/products/${handle}`;

    const rawImage =
      product.featured_image ||
      product.images?.[0] ||
      '';

    const imageUrl =
      typeof rawImage === 'string'
        ? rawImage.startsWith('//')
          ? 'https:' + rawImage
          : rawImage
        : rawImage?.src || '';

    if (imageUrl) {
      const img =
        document.createElement('img');

      img.src = imageUrl;
      img.alt =
        product.title || '';
      img.loading = 'lazy';

      coverLink.appendChild(img);
    }

    const body =
      document.createElement('div');

    body.className =
      'card-body';

    if (product.vendor) {
      const vendor =
        document.createElement('div');

      vendor.className =
        'vendor';

      vendor.textContent =
        product.vendor;

      body.appendChild(vendor);
    }

    const title =
      document.createElement('a');

    title.className =
      'title';

    title.href =
      `/products/${handle}`;

    title.textContent =
      product.title || handle;

    body.appendChild(title);

    const variants =
      Array.isArray(
        product.variants
      )
        ? product.variants
        : [];

    const variant =
      variants.find(
        v => v.available
      ) ||
      variants[0];

    const price =
      document.createElement(
        'div'
      );

    price.className =
      'price';

    price.textContent =
      money(
        typeof variant?.price ===
          'number'
          ? variant.price
          : product.price
      );

    body.appendChild(price);

    const actions =
      document.createElement(
        'div'
      );

    actions.className =
      'actions';

    const view =
      document.createElement('a');

    view.className = 'view';
    view.href =
      `/products/${handle}`;
    view.textContent = 'Zobacz';

    actions.appendChild(view);

    const add =
      document.createElement(
        'button'
      );

    add.className = 'add';
    add.type = 'button';

    if (
      variant?.available &&
      variant?.id
    ) {
      add.textContent =
        'Dodaj do koszyka';

      add.addEventListener(
        'click',
        () =>
          addToCart(
            variant.id,
            add
          )
      );
    } else {
      add.textContent =
        'Niedostępna';

      add.disabled = true;
    }

    actions.appendChild(add);

    body.appendChild(actions);

    card.append(
      coverLink,
      body
    );

    return card;
  }

  async function addProductCards(
    stack,
    bubble,
    answer
  ) {
    const handles =
      productRefs(answer);

    if (!handles.length) {
      return;
    }

    const cleaned =
      stripProductUrls(answer);

    if (cleaned) {
      bubble.textContent =
        cleaned;
    }

    const cards =
      document.createElement(
        'div'
      );

    cards.className =
      'cards';

    const data =
      await Promise.all(
        handles.map(
          async handle => {
            try {
              return {
                handle,
                product:
                  await fetchProduct(
                    handle
                  )
              };
            } catch (e) {
              console.warn(
                '[WKOŁO Support] product card',
                handle,
                e
              );

              return null;
            }
          }
        )
      );

    data
      .filter(Boolean)
      .forEach(item => {
        cards.appendChild(
          buildCard(
            item.product,
            item.handle
          )
        );
      });

    if (
      cards.childElementCount
    ) {
      stack.appendChild(cards);
      scrollBottom();
    }
  }

  async function sendMessage(raw) {
    const message =
      String(raw || '').trim();

    if (!message || busy) {
      return;
    }

    openPanel();

    const priorHistory =
      history.slice(
        -MAX_HISTORY
      );

    addMessage(
      'user',
      message
    );

    history.push({
      role: 'user',
      content: message
    });

    history =
      history.slice(
        -MAX_HISTORY
      );

    saveHistory();

    input.value = '';
    autoGrow();

    setBusy(true);

    const assistant =
      addMessage(
        'assistant',
        'Sprawdzam…',
        true
      );

    let assistantText = '';

    try {
      const r = await fetch(
        ENDPOINT,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json'
          },
          body: JSON.stringify({
            message,
            history:
              priorHistory,
            oglada:
              PRODUCT_TITLE
          })
        }
      );

      if (!r.ok) {
        throw new Error(
          `backend ${r.status}: ${(await r.text()).slice(
            0,
            150
          )}`
        );
      }

      if (!r.body) {
        throw new Error(
          'brak body'
        );
      }

      const reader =
        r.body.getReader();

      const decoder =
        new TextDecoder();

      let buffer = '';

      function consume(line) {
        line = line.trim();

        if (!line) {
          return;
        }

        let event;

        try {
          event =
            JSON.parse(line);
        } catch {
          return;
        }

        if (
          typeof event.t ===
          'string'
        ) {
          assistantText +=
            event.t;

          setBubble(
            assistant.bubble,
            assistantText
          );
        }
      }

      while (true) {
        const {
          value,
          done
        } =
          await reader.read();

        if (done) {
          break;
        }

        buffer +=
          decoder.decode(
            value,
            {
              stream: true
            }
          );

        const lines =
          buffer.split('\n');

        buffer =
          lines.pop() || '';

        lines.forEach(
          consume
        );
      }

      buffer +=
        decoder.decode();

      if (buffer.trim()) {
        buffer
          .split('\n')
          .forEach(
            consume
          );
      }

      if (
        !assistantText.trim()
      ) {
        assistantText =
          'Nie udało mi się przygotować odpowiedzi. Spróbuj proszę ponownie.';

        setBubble(
          assistant.bubble,
          assistantText
        );
      }

      history.push({
        role: 'assistant',
        content:
          assistantText
      });

      history =
        history.slice(
          -MAX_HISTORY
        );

      saveHistory();

      try {
        await addProductCards(
          assistant.stack,
          assistant.bubble,
          assistantText
        );
      } catch (e) {
        console.warn(
          '[WKOŁO Support] cards',
          e
        );
      }
    } catch (e) {
      console.error(
        '[WKOŁO Support]',
        e
      );

      setBubble(
        assistant.bubble,
        'Coś poszło nie tak po stronie czatu. Spróbuj proszę ponownie.'
      );
    } finally {
      setBusy(false);
      input.focus();
    }
  }

  // WAŻNE:
  // widget nie używa <form>,
  // więc Enter ani kliknięcie
  // nie mogą przeładować strony.

  send.addEventListener(
    'click',
    e => {
      e.preventDefault();
      e.stopPropagation();

      sendMessage(
        input.value
      );
    }
  );

  input.addEventListener(
    'keydown',
    e => {
      if (
        e.key === 'Enter' &&
        !e.shiftKey
      ) {
        e.preventDefault();
        e.stopPropagation();

        sendMessage(
          input.value
        );
      }
    }
  );

  input.addEventListener(
    'input',
    autoGrow
  );

  launcher.addEventListener(
    'click',
    e => {
      e.preventDefault();
      e.stopPropagation();

      openPanel();
    }
  );

  closeBtn.addEventListener(
    'click',
    e => {
      e.preventDefault();
      e.stopPropagation();

      closePanel();
    }
  );

  chips.forEach(btn => {
    btn.addEventListener(
      'click',
      e => {
        e.preventDefault();
        e.stopPropagation();

        sendMessage(
          btn.dataset.prompt ||
          ''
        );
      }
    );
  });

  contextA.addEventListener(
    'click',
    e => {
      e.preventDefault();
      e.stopPropagation();

      sendMessage(
        'Czy ta książka będzie dobra dla mnie? Krótko wyjaśnij, dla kogo jest.'
      );
    }
  );

  contextB.addEventListener(
    'click',
    e => {
      e.preventDefault();
      e.stopPropagation();

      sendMessage(
        'Porównaj tę książkę z 1–2 najlepszymi alternatywami z oferty WKOŁO.'
      );
    }
  );

  nudge.addEventListener(
    'click',
    e => {
      if (
        e.target ===
        nudgeX
      ) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      openPanel();
    }
  );

  nudgeX.addEventListener(
    'click',
    e => {
      e.preventDefault();
      e.stopPropagation();

      nudge.classList.remove(
        'show'
      );
    }
  );

  document.addEventListener(
    'keydown',
    e => {
      if (
        e.key === 'Escape'
      ) {
        closePanel();
      }
    }
  );

  if (PRODUCT_TITLE) {
    context.classList.add(
      'visible'
    );

    addMessage(
      'assistant',
      `Cześć! Jestem Support. Widzę, że oglądasz „${PRODUCT_TITLE}”. Mogę powiedzieć, dla kogo jest ta książka albo porównać ją z innymi.`
    );
  } else {
    addMessage(
      'assistant',
      'Cześć! Jestem Support. Wybierz temat albo napisz, jakiej książki szukasz.'
    );
  }

  history.forEach(
    item =>
      addMessage(
        item.role,
        item.content
      )
  );

  autoGrow();

  // Delikatna zachęta
  // tylko raz na sesję.
  try {
    if (
      sessionStorage.getItem(
        'wkolo_support_safe_nudge'
      ) !== '1'
    ) {
      setTimeout(() => {
        if (
          !panel.classList.contains(
            'open'
          )
        ) {
          nudge.classList.add(
            'show'
          );

          sessionStorage.setItem(
            'wkolo_support_safe_nudge',
            '1'
          );

          setTimeout(
            () =>
              nudge.classList.remove(
                'show'
              ),
            9000
          );
        }
      }, 12000);
    }
  } catch {}
})();